export const SOCIAL_LANGUAGE_KEY = 'en-social';
export const OP_WRAPPER_LOCALIZATION_PREFIX = 'OPWrapperService';
export const OP_WRAPPER_TOURNAMENTS_LOCALIZATION_PREFIX = 'tournament_';
export const OP_WRAPPER_GAME_LIMITS_STORAGE_KEY = 'OPWrapper_service_game_limits';
export const OP_WRAPPER_TOURNAMENTS_START_SCREEN_STORAGE_KEY = 'OPWrapperService_tournaments_start_screen';
export const OP_WRAPPER_TOURNAMENTS_UPCOMING_SCREEN_STORAGE_KEY = 'OPWrapperService_tournaments_upcoming_screen';
